const
  NAME               = 'dynamicGrid',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

const
  SPONSORED_CLASS         = 'voc-sponsored',
  RELATED_CLASS           = 'voc-related',
  PULL_RIGHT_CLASS        = 'pull-right',
  RELATED_GRID_CLASSES    = 'col-xs-12 col-sm-9 col-md-9 col-lg-9',
  RELATED_GRID_LI_CLASSES = 'col-xs-12 col-sm-4 col-md-4 col-lg-4'
;

class DynamicGrid {
  constructor(element$) {
    this._element$     = element$;
    this._sponsoredEl$ = element$.find(`.${SPONSORED_CLASS}`);
    this._relatedEl$   = element$.find(`.${RELATED_CLASS}`);

    this._sponsoredEl$.on('vam:slotrendered', this.changeGrid.bind(this));
  }

  changeGrid() {
    this._sponsoredEl$.removeClass('hidden');
    this._relatedEl$.removeClass().addClass(`${RELATED_CLASS} ${PULL_RIGHT_CLASS} ${RELATED_GRID_CLASSES}`);
    this._relatedEl$.find('li').removeClass().addClass(RELATED_GRID_LI_CLASSES);
    if (this._relatedEl$.find('li').length === 4) {this._relatedEl$.find('li:last').hide();}
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new DynamicGrid($(this), options);
    });
  }
}

$.fn[NAME]             = DynamicGrid._jQueryInterface;
$.fn[NAME].Constructor = DynamicGrid;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return DynamicGrid._jQueryInterface;
};

export default DynamicGrid;



// WEBPACK FOOTER //
// ./src/plugins/dynamic-grid.js